module.exports = __webpack_public_path__ + "media/images/product-img-06-53568532b5dc8435505a0c2753f06f55.jpeg";